import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { TableTree } from "components/TableTree/TableTree";
import { useEffect, useState } from "react";

import { Button } from "components/Button/Button";
import { DataGrid } from "components/DataGrid/DataGrid";
import { Search } from "components/Search/Search";
import { SwitchBtn } from "components/SwitchBtn/SwitchBtn";
import { Toast } from "components/ToastShow/ToastAlert";
import { INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { getPageSize, trans } from "utils/helpers";
import { getItemPriceList, getItemPriceTree } from "./api";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { MessageType } from "types/enum";
import { getItemGroup, getItemGroupTree } from "pages/InventoryAndSales/Inventory/ItemTree/api";

interface Prop {
  itemCodeHandeler: (e, bool,hasPriceUnit) => void;
  onHide: () => void;
  warehouseId?: any;
  warehouseDetailId?: any;
  priceListId?: any;
  isWarehouseItem?: boolean;
  isGroup?: boolean;
  defualtHasPriceUnit?: boolean;
}

export const ItemsForPriceList = ({
  itemCodeHandeler,
  isWarehouseItem,
  defualtHasPriceUnit,
  warehouseId,
  warehouseDetailId,
  isGroup,
  priceListId,
  onHide,
}: Prop) => {
  const [data, setData] = useState<any>();
  const [forceUpdate, setForceUpdate] = useState<boolean>(false);
  const [selectedObj, setSelectedObj] = useState<any>();
  const [idCallback, setIdCallback] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [message, setMessage] = useState<any>("NoDataForPreview");
  const [pageNum, setPageNum] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [pages, setPages] = useState<number>(0);
  const [filterlist, setFilterlist] = useState<any>("");
  const [showMode, setShowMode] = useState<any>(null);
  const [orderBy, setOrderBy] = useState<any>([]);
  const [search, setSearch] = useState(null);
  const [hasPriceUnit, setHasPriceUnit] = useState<any>(defualtHasPriceUnit);


  const setselecetrow = (e) => {
    setSelectedObj(e);
  };
  const sendTreeCode = (e, obj = selectedObj) => {
    e?.preventDefault();
    e?.stopPropagation();
    if (obj) {   
      itemCodeHandeler(obj, !showMode,hasPriceUnit);
    } else {
      // Toast(trans("Msg_SelectRow"), "warning");
      Toast(trans("Msg_SelectRow"), MessageType.warning);

    }
  };

  const searchHandler = (str) => {
    setPageNum(1);
    setSelectedObj(null);
    if (str === "") {
      setSearch(null);
      getItemsForPriceListAsync(1);
    } else {
      setSearch(str);
      getItemsForPriceListAsync(1);
    }
  };

  const handlechangePageSize = (e: any) => {
    setPageNum(1);
    setPageSize(e.currentTarget.value);
    getPageSize("ItemsForPriceList2", e.currentTarget.value);
    getItemsForPriceListAsync(1);
  };

  const handleGoPage = (value) => {
    if (value) {
      if (value < 1 || value > pages) {
      } else setPageNum(+value);
      getItemsForPriceListAsync(+value);
    } else {
    }
  };
  const handleNextPage = () => {
    if (pageNum < pages) {
      setPageNum(pageNum + 1);
      getItemsForPriceListAsync(pageNum + 1);
    }
  };
  const handlePrevPage = () => {
    if (pageNum > 1) {
      setPageNum((pageNum) => {
        return +pageNum - 1;
      });
      getItemsForPriceListAsync(pageNum - 1);
    }
  };

  
  
  async function getItemsForPriceListAsync(PageNum = pageNum) {
    setLoading(false);
    let pageSizeChangedByUser = getPageSize("ItemsForPriceList2");
    setPageSize(pageSizeChangedByUser);

    try {
      if (showMode) {
        const respons = !isGroup ? await getItemPriceTree(
          warehouseId == "allWarehouses" ? null : warehouseId,
          isWarehouseItem,
          warehouseDetailId,
          hasPriceUnit,
          priceListId,
        ):   await getItemGroupTree(null)



        setData(respons.Data);
      } else {
        const respons =!isGroup ? await getItemPriceList(
            warehouseId == "allWarehouses" ? null : warehouseId,
            isWarehouseItem,
            warehouseDetailId,
            PageNum,
            pageSizeChangedByUser,
            orderBy.length == 0 ? null : orderBy.join(","),
            search,
            filterlist,
            hasPriceUnit,
            priceListId,
          ):   await getItemGroup( warehouseId ,PageNum,  pageSizeChangedByUser ,orderBy.length == 0 ?null:  orderBy.join(",") ,search,filterlist)

          setPages(
            respons.Data.TotalRecords > pageSizeChangedByUser
              ? Math.ceil(respons.Data.TotalRecords / pageSizeChangedByUser)
              : 1
          );
          setData(respons.Data);
      }
    } catch (err: any) {
      setMessage(err?.data?.Message);
    }
    setLoading(true);
  }

  useEffect(() => {
   if(showMode!==null) {
     setData(null);
     getItemsForPriceListAsync();

    }
  }, [forceUpdate, showMode, search, filterlist, orderBy ,hasPriceUnit]);

  useEffect(() => {
    if (idCallback) {
      setIdCallback(null);
    }
  }, [idCallback]);

  return (
    <>
      <div className="row align-items-start justify-content-between">
      <div className="col ">
            <Search
              onChange={searchHandler}
            />
        {!isGroup&&
          <div >
             <CheckableButton
                defaultChecked={hasPriceUnit}
                defaultValue={hasPriceUnit}
                onchange={setHasPriceUnit}
                labelText={"hasPriceListUnitOnly"}
                inputName={"hasPriceUnit"}
                type="checkbox"
                mode={"edit"}
                />
          </div>
        }
        </div>
        <div className="col h-100 text-start d-flex justify-content-end ">
          <div style={{ maxWidth: "150px", height: "100%" }}>
            <SwitchBtn
              handleModeCard={(e)=>setShowMode(e)}
              setShape="circle"
              firstMode={'AsTree'}
              secondMode={'AsList'}
              treeMode={true}
              parentModalName={'itemsForPriceList'}
            />
          </div>
        </div>
          <div className="col-lg-12 my-1 btns_form">
            <Button
              value="select"
              btnType="submit"
              onClick={(e) => {
                sendTreeCode(e);
              }}
            />
            <Button
              btnType="cancel"
              value="Cancel"
              onClick={(e) => {
                onHide();
              }}
            />
          </div>
      </div>

      <div
        style={{  overflowY: "auto", 
          height: "70vh",
           scrollbarWidth: "thin" }}
      >
        {loading ? (
          data ? (
            <>
              {!showMode ? (
                <div>
                  {data?.Data ? (
                    <DataGrid
                      useChangingNumberPlacement={true}
                      parentName={"ItemsForPriceList2"}
                      theadData={Object.keys(data.Data[0])}
                      tbodyData={data.Data}
                      minCellWidth={80}
                      DoubleClick={(e) => {
                        sendTreeCode(null, e);
                      }}
                      selectedRowObjectCallback={setselecetrow}
                      totalRecords={data.TotalRecords}
                      pageNum={pageNum}
                      orderFormat={setOrderBy}
                      orderFormatList={orderBy}
                      handlefiltering={(str) => {
                        setFilterlist(str);
                      }}
                      filterStr={filterlist}
                      pageSize={pageSize}
                      HandleNextPage={handleNextPage}
                      HandlePrevPage={handlePrevPage}
                      handlechangePageSize={handlechangePageSize}
                      first={() => {
                        getItemsForPriceListAsync(pages);
                        setPageNum(pages);
                      }}
                      end={() => {
                        getItemsForPriceListAsync(1);
                        setPageNum(1);
                      }}
                      handleGoPage={handleGoPage}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              ) : (
                <div>
                  {data && data?.length > 0 && (
                    <TableTree
                      baseUrl={INVENTORYANDSALES_URL}
                      selectedRowObjectCallback={setselecetrow}
                      selectedRowObject={idCallback}
                      DoubleClick={(e) => {
                        sendTreeCode(null, e);
                      }}
                      getChildrenUrl={
                        ENDPOINTSINVENTORYANDSALES.Sales.BaseInformationApi
                          .PriceListDetailApis.itemsTree
                      }
                      theadData={[
                        "Id",
                        "ParentId",
                        "Children",
                        "Description",
                        "Code",
                      ]}
                      startIndex={2}
                      defultparams={{
                        priceListId:priceListId,
                        warehouseId: warehouseId
                          ? warehouseId == "allWarehouses"
                            ? null
                            : warehouseId
                          : JSON.parse(localStorage.getItem("DefaultInventory") + "")
                              ?.Id,hasPriceListUnitOnly:hasPriceUnit
                      }}
                      Titleparams={"Description"}
                      Childrenparams={"Children"}
                      defultShow={false}
                      Data={data}
                      parentName={"ItemsForPriceList"}
                    />
                  )}
                </div>
              )}
            </>
          ) : (
            <Message message={message} type={"error"} />
          )
        ) : (
          <Loading />
        )}
      </div>
    </>
  );
};
